export default {
  name: 'cool-features-slider',
  components: {
  },
  props: {
    isEmpty: {
      default: false,
      type: Boolean,
    }
  },
  data(){
    return {
      isTouchingNow: false,
      images:[],          //возвращаются после ajaх-запроса в mounted
      elementId: null,    //int, берется из data-attribute
    }
  },
  methods: {
    openGallery(){
      if (this.isEmpty) return;
      this.$store.commit('setIsGalleryOpen', true)
      this.$store.commit('setGalleryItems', this.images)
    },
    getImages(){
      api.get(
        'gallery-slide/get',
        {
          params: {
            elementID: this.elementId,
          }
        },
      )
        .then((res)=>{
          // console.log(res.data)
          this.images = res.data
          //временно. Чтобы после перезагрузки сразу открывалось
          // this.openGallery();
        })
    },
    initDataAttrsToData(){
      this.elementId = this.$el.dataset.elementId;
    }
  },
  mounted(){
    this.initDataAttrsToData();
    this.getImages();
    
    // для удобства разработки. Не забывать комментить перед мержем в девелоп
    // setTimeout(()=>{
    //   this.openGallery();
    // },500)
    
  }
}



// WEBPACK FOOTER //
// ./src/includes/CoolFeaturesSlider.js